import WebFont from 'webfontloader'

export const loadFonts = (): void => {
  WebFont.load({
    google: {
      families: ['Inter:400,500,600', 'Montserrat:400,500,600,700']
    }
  })
}
